import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { logOut } from '../store/auth/actions';
import routes from '../constants/routes';
import { LOCAL_STORAGE } from '../constants/constants';

const useLocalStorage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    const syncAuth = (event) => {
      if (event.key === LOCAL_STORAGE.KEYS.AUTH_EVENT) {
        try {
          const value = JSON.parse(event.newValue);

          switch (value.name) {
            case LOCAL_STORAGE.EVENTS.LOGOUT:
              dispatch(logOut());
              navigate(routes.login);
              break;

            case LOCAL_STORAGE.EVENTS.LOGIN:
              window.location.reload();
              break;

            default:
              break;
          }
        } catch (err) {
          console.error('Error parsing event data', err);
        }
      }
    };

    window.addEventListener('storage', syncAuth);
    return () => window.removeEventListener('storage', syncAuth);
  }, [dispatch, navigate]);
};

export default useLocalStorage;
